module.exports = __webpack_public_path__ + "media/site/images/products/eplaning-flat-screen3@2x-e1b886b3bc2fcfb5094ec7546dea6450.png";